/**
 * Guarded `localStorage`. Safari in Lockdown Mode and Chrome with site data
 * blocked make `localStorage` itself throw on property access, not just on
 * write, and a thrown getter would take down the whole boot. So every access
 * goes through here, and a failure reads as "nothing stored".
 */

export function read(key: string): string | null {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

export function write(key: string, value: string): void {
  try {
    localStorage.setItem(key, value)
  } catch {
    // Private mode, quota, or storage disabled. Preferences are expendable.
  }
}

export function remove(key: string): void {
  try {
    localStorage.removeItem(key)
  } catch {
    // See write().
  }
}

export function readJson<T>(key: string): T | null {
  const raw = read(key)
  if (!raw) return null
  try {
    return JSON.parse(raw) as T
  } catch {
    return null // Corrupt entry from an older build; ignore rather than clear.
  }
}
